import React from "react";
import UserHeader from "../UserHeader";
import ListingHeader from "../ListingHeader";
import { useStyles } from "./style";
import { Box } from "@material-ui/core";
import { Helmet } from "react-helmet";

const ListingLayout = ({
  item,
  title,
  redirect,
  // Content
  children,
  // Button
  hasFilter,
  hasDateFilter,
  hasSorting,
  hasAddTitle,
  addTitle,
  // Button Icon
  hideAdd,
  // Button Actions
  onFilterAction,
  onDateFilter,
  onFilterSorting,
  // Location Toggler
  showLocationToggle,
  // Add Modal
  isAddModal,
  onAddModal,
  //
  paths,
  showProfileTabs,
  profileLocation,
  //
  hasListFilter,
  listfilter,
  onListFilterClick,
  activeListFilter,
  stats,
  hasCount,
  hasCardActions,
  onCardAction,
  cardActionTitle,
  hideOrder,
  showInfoText,
  infoText,
  hasLargeContent,
  hasMediumContent,
  hasFullContent,
  hasYear,
  year,
  onYear,
  yearList,
  hasViewToggle,
  showTimeline,
  onViewChange,
  hasTaskToggle,
  onTaskToggle,
  taskToggle,
  hideHeader,
  hasCsvmodal,
  onCsvAction,
  onLocationChange,
  customContent,
  taskToggleLabel,
}) => {
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box className={classes.header}>
        <UserHeader
          title={title}
          showLocationToggle={showLocationToggle}
          profileTabs={paths}
          showProfileTabs={showProfileTabs}
          profileLocation={profileLocation}
          onLocationChange={onLocationChange}
        />
      </Box>
      <Box
        className={
          hasMediumContent
            ? `${classes.content} ${classes.contentMD}`
            : hasLargeContent
            ? `${classes.content} ${classes.contentLG}`
            : hasFullContent
            ? `${classes.content} ${classes.contentFull}`
            : `${classes.content}`
        }
      >
        <ListingHeader
          title={title}
          redirect={redirect}
          item={item}
          hasFilter={hasFilter}
          hasDateFilter={hasDateFilter}
          hasSorting={hasSorting}
          onFilterAction={onFilterAction}
          onFilterSorting={onFilterSorting}
          onDateFilter={onDateFilter}
          hideAdd={hideAdd}
          isAddModal={isAddModal}
          onAddModal={onAddModal}
          hasAddTitle={hasAddTitle}
          addTitle={addTitle}
          hasListFilter={hasListFilter}
          listfilter={listfilter}
          onListFilterClick={onListFilterClick}
          activeListFilter={activeListFilter}
          stats={stats}
          hasCount={hasCount}
          hasCardActions={hasCardActions}
          onCardAction={onCardAction}
          cardActionTitle={cardActionTitle}
          hideOrder={hideOrder}
          showInfoText={showInfoText}
          infoText={infoText}
          hasYear={hasYear}
          year={year}
          onYear={onYear}
          yearList={yearList}
          hasViewToggle={hasViewToggle}
          showTimeline={showTimeline}
          onViewChange={onViewChange}
          showProfileTabs={showProfileTabs}
          hasTaskToggle={hasTaskToggle}
          onTaskToggle={onTaskToggle}
          taskToggle={taskToggle}
          hideHeader={hideHeader}
          hasCsvmodal={hasCsvmodal}
          onCsvAction={onCsvAction}
          customContent={customContent}
          taskToggleLabel={taskToggleLabel}
        />
        {children}
      </Box>
    </>
  );
};

export default ListingLayout;
